// import gsap from 'gsap';
import $ from "jquery";
export default function headerLangToggle() {
	let gsap  = window.gsap;
	
	if (gsap) {
		const headerLangOpen = () => {
			gsap.to('.header-lang-wrapper', {
				display: 'block',
				duration: 0.5,
				ease: "power1.in",
			})
		}

		const headerLangClose = () => {
			gsap.to('.header-lang-wrapper', {
				display: 'none',
				duration: 0.5,
				ease: "power1.in",
			})
		}

		const headerLangOpenDesktop = () => {
			gsap.to('.header-lang-wrapper-desktop', {
				display: 'block',
				duration: 0.5,
				ease: "power1.in",
			})
			$( 'body' ).addClass( 'overflow-hidden' );
		}

		const headerLangCloseDesktop = () => {
			gsap.to('.header-lang-wrapper-desktop', {
				display: 'none',
				duration: 0.5,
				ease: "power1.in",
			})
			$( 'body' ).removeClass( 'overflow-hidden' );
		}


		const langCurrent = document.querySelector('.header-mobile .lang-current');
		if (langCurrent) {
			langCurrent.addEventListener('click', () => {
				headerLangOpen();
			});
		}


		const headerLangCloseBtn = document.querySelector('.header-mobile .header-lang-close');
		if (headerLangCloseBtn) {
			headerLangCloseBtn.addEventListener('click', () => {
				headerLangClose();
			})
		}


		const langCurrentDesktop = document.querySelector('.header-topbar .lang-current');
		if (langCurrentDesktop) {
			langCurrentDesktop.addEventListener('click', () => {
				headerLangOpenDesktop();
			});
		}

		$('.header-lang-open').on('keydown', function (e) {
			if (e.key === 'Enter') {
				e.preventDefault(); // Prevent default only when handling 'Enter'
				headerLangOpenDesktop();
			}
		});

		const headerLangCloseBtnDesktop = document.querySelector('.header-topbar .header-lang-close');
		if (headerLangCloseBtnDesktop) {
			headerLangCloseBtnDesktop.addEventListener('click', () => {
				headerLangCloseDesktop();
			})
		}
	}
}
